import { render, staticRenderFns } from "./ColorSizeButton.vue?vue&type=template&id=d499af62&scoped=true&"
import script from "./ColorSizeButton.vue?vue&type=script&lang=js&"
export * from "./ColorSizeButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorSizeButton.vue?vue&type=style&index=0&id=d499af62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d499af62",
  null
  
)

export default component.exports